import { render, staticRenderFns } from "./report-more.vue?vue&type=template&id=74d81863&scoped=true"
import script from "./report-more.vue?vue&type=script&lang=js"
export * from "./report-more.vue?vue&type=script&lang=js"
import style0 from "./report-more.vue?vue&type=style&index=0&id=74d81863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d81863",
  null
  
)

export default component.exports